<template>
	<div class="area row-center">
		<img :src="details.areaImg" alt="">
		<div class="column-center" :style="'width:' + width/1920 * 100 + 'vw'">
			<div class="name row-center">
				<h1>{{details.areaName}}</h1>
				<img style="cursor: pointer" src="../../assets/img/change0.png" alt="">
			</div>
			<p>{{details.areaDirection}}</p>
		</div>
	</div>
</template>

<script>

	export default {
		name: "AreaDetails",
		props:["width", 'details'],
		mounted() {

		}
	}
</script>

<style scoped lang="less">
	p, h1 {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}
	.area {
		justify-content: space-between;
		padding: 16rem 24rem;
		border-bottom: 1px solid #E5E5E5;


		> img {
			.w(64);
			.h(64);
			margin-right: 15rem;
		}

		> div {
			.h(64);
			justify-content: space-between !important;


			p {
				width: 100%;
				font-size: 16rem;
				color: #999999;
			}
		}

		.name {
			justify-content: space-between;
			width: 100%;

			h1 {
				font-size: 24rem;
				font-weight: bold;
				color: #333333;
				max-width: 140 / 1920 * 100vw;
			}
		}
	}
</style>